var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('VueLoadingIndicator',{staticClass:"overlay big"}):_c('div',{staticClass:"pb-6",attrs:{"id":"app"}},[_c('Nav'),_c('router-view',{key:_vm.$route.path})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }